import { PageHero } from "./Services";
import { SITE } from "../lib/site";
import { Reveal, MaskedLineOnView } from "../components/Reveal";
import BrandMarquee from "../components/BrandMarquee";

export default function About() {
  const chapters = [
    {
      n: "01",
      t: "A Philly counter, not a call center.",
      d: "We're on Bustleton Ave, first floor, doors open seven days a week. When you call, a person picks up. When you walk in, we know the paperwork before you finish explaining.",
    },
    {
      n: "02",
      t: "Multilingual, patient, and precise.",
      d: "English and Spanish. Every form checked twice before submission. Every fee explained line by line. We treat every customer like a neighbor — because most of them are.",
    },
    {
      n: "03",
      t: "One roof for the whole run-around.",
      d: "Titles, tags, notary, insurance — we consolidated the entire vehicle-ownership loop into a single visit, so everything gets handled in one convenient Northeast Philadelphia location.",
    },
    {
      n: "04",
      t: "Fair pricing, publicly stated.",
      d: "PennDOT fees are what they are. Our service fees are transparent, itemized, and never inflated. If a competitor charges less, ask them why they can't finish the job today.",
    },
  ];

  return (
    <>
      <PageHero
        eyebrow="About Rhawn"
        title={
          <>
            The counter <span className="italic text-[#C5A059]">Philly</span>
            <br /> trusts to close it out.
          </>
        }
        image={SITE.images.office}
      />

      <section className="py-24 lg:py-40 bg-[#FBF9F5]" data-testid="about-section">
        <div className="max-w-[1500px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-14">
          <div className="lg:col-span-4 sticky top-28 self-start">
            <div className="label-mini">Manifesto</div>
            <h2 className="font-serif mt-6 text-5xl md:text-6xl leading-[1.02] text-[#0A192F]">
              <MaskedLineOnView>Small counter.</MaskedLineOnView>
              <MaskedLineOnView delay={0.1}>Serious business.</MaskedLineOnView>
            </h2>
          </div>

          <div className="lg:col-span-7 lg:col-start-6 space-y-24">
            {chapters.map((c, i) => (
              <Reveal key={c.n} delay={i * 0.05}>
                <div className="relative">
                  <span className="chapter-num text-[22vw] lg:text-[10rem] absolute -top-16 -left-4 select-none">
                    {c.n}
                  </span>
                  <div className="relative">
                    <div className="label-mini text-[#C5A059]">Chapter {c.n}</div>
                    <h3 className="mt-4 font-serif text-3xl md:text-4xl leading-tight text-[#0A192F] max-w-xl">
                      {c.t}
                    </h3>
                    <p className="mt-5 text-[#0A192F]/70 max-w-xl leading-relaxed">
                      {c.d}
                    </p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <BrandMarquee
        items={["Trust", "Speed", "Craft", "Philadelphia", "Third-Party Processor", "Multilingual"]}
        speed={30}
      />
    </>
  );
}
